module.exports = __webpack_public_path__ + "static/img/USDT.80ed764.80ed764.png";


//////////////////
// WEBPACK FOOTER
// ./src/OK_Scott/assets/image/USDT.80ed764.png
// module id = X7vB
// module chunks = 1